import styled from 'styled-components';
const S = {};

const LightTextColor = ({ theme: { $iwgLightTextColor } }) => `${$iwgLightTextColor}`;
const DarkTextColor = ({ theme: { $iwgDarkTextColor } }) => `${$iwgDarkTextColor}`;
const PrimaryColor = ({ theme: { $iwgMainColor } }) => `${$iwgMainColor}`;
const SecondaryColor = ({ theme: { $iwgSecondaryColor } }) => `${$iwgSecondaryColor}`;
const RedTextColor = ({ theme: { $iwgRedTextColor } }) => `${$iwgRedTextColor}`;
const GreenTextColor = ({ theme: { $iwgGreenTextColor } }) => `${$iwgGreenTextColor}`;
const InfoBorderColor = ({ theme: { $iwgInfoBorderColor } }) => `${$iwgInfoBorderColor}`;

S.InstantWinGamesTopTab = styled.div`
  display: flex;
  width: 100%;
`;

S.BalanceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 1rem;
  width: 100%;
  height: 3.5rem;
  padding: 0 1rem;
  background-color: ${SecondaryColor};
  color: ${DarkTextColor};
  font-weight: 700;
  font-size: 1rem;
`;

S.BalanceBox = styled.div`
  flex: 1 0 auto;
  display: flex;
  justify-content: end;
  align-items: center;
  border-radius: 4px;
  padding-right: 0.5rem;
  height: 1.75rem;
  background-color: ${DarkTextColor};
  font-size: 14px;
  text-align: right;
  color: white;
`;

S.BalanceLabel = styled.span`
  font-size: 12px;
`

S.PaymentBalanceInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 0.65rem 0;
  background-color: ${SecondaryColor};
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
`;

S.PaymentSessionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  color: ${(props) => (props.isSessionActive ? GreenTextColor : RedTextColor)};
`;

S.PaymentBalanceWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`;

S.PaymentBalanceBox = styled.div`
  min-width: 8rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  padding: 0.25rem 0;
  padding-right: 0.5rem;
  background-color: ${DarkTextColor};
  font-size: 14px;
  text-align: right;
  color: ${LightTextColor};
`;

S.InfoIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1.1rem;
  height: 1.1rem;
  margin-left: 0.5rem;
  border-radius: 50%;
  border: 0.17rem solid ${InfoBorderColor};
`;

S.DepositButton = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 1.75rem;
  padding: 0 0.31rem 0 2.2rem;
  border-radius: 0.25rem;
  background-color: ${PrimaryColor};
  color: ${LightTextColor};
  cursor: pointer;
  font-weight: 700;
  font-size: 0.8rem;
`;

S.DepositIcon = styled.i`
  position: absolute;
  top: 0.31rem;
  bottom: 0;
  left: 0.6rem;
  margin: auto 0;
  width: 1.4rem;
  height: 1.4rem;
`;

export default S;
